import { NOTIFICATION_CLEAR, NOTIFICATION_SET } from "../store/config";

export const newNotification = (data) => {
	return dispatch => {
		return dispatch(setNotification(data));
	}
}

export const setNotification = (data) => {
	return {
		type: NOTIFICATION_SET,
		data: data,
		active: true,
		timestamp: Date.now()
	}
}

export const clearNotification = () => {
	return dispatch => {
		return dispatch(unsetNotification());
	}
}

export const unsetNotification = () => {
	return {
		type: NOTIFICATION_CLEAR,
		data: {},
		active: false,
		timestamp: Date.now()
	}
}


// WEBPACK FOOTER //
// ./src/actions/notifications.js